export enum ButtonState {
  ACTIVE,
  DISABLED,
  OUTLINED
}
